import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { StoreModule } from '@ngrx/store';

import { ButtonComponent } from '@fcom/ui-components/components/buttons/button/button.component';
import { IconButtonComponent } from '@fcom/ui-components/components/buttons/icon-button/icon-button.component';
import { DatepickerComponent } from '@fcom/ui-components/components/datepicker/datepicker/datepicker.component';
import { CheckboxInputComponent } from '@fcom/ui-components/components/forms/checkbox-input/checkbox-input.component';
import { RadioItemGroupComponent } from '@fcom/ui-components/components/forms/radio-item-group/radio-item-group.component';
import { SelectInputComponent } from '@fcom/ui-components/components/forms/select-input/select-input.component';
import { TextInputComponent } from '@fcom/ui-components/components/forms/text-input/text-input.component';
import { IconComponent } from '@fcom/ui-components/components/icons/icon/icon.component';
import { LinkComponent } from '@fcom/ui-components/components/link/link.component';
import { LoaderComponent } from '@fcom/ui-components/components/loader/loader.component';
import { ModalComponent } from '@fcom/ui-components/components/modal/modal.component';
import { NotificationComponent } from '@fcom/ui-components/components/notifications/notification/notification.component';
import { PopoverDirective } from '@fcom/ui-components/components/popover/directive/popover.directive';
import { TabComponent } from '@fcom/ui-components/components/tabs/tab/tab.component';
import { TabsComponent } from '@fcom/ui-components/components/tabs/tabs/tabs.component';
import { TagComponent } from '@fcom/ui-components/components/tag/tag.component';
import { UiTranslateModule } from '@fcom/ui-translate';
import { PipesModule } from '@fcom/common/pipes/pipes.module';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { FinFormsModule } from '@fcom/common/forms/forms.module';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { LoginModule } from '@fcom/common/login/login.module';

import { BOOKING_WIDGET_FEATURE_KEY } from './store/constants';
import { BookingWidgetAmService } from './services/booking-widget-am.service';
import { AirCalendarComponent } from './components/air-calendar/air-calendar.component';
import { AmBookingWidgetComponent } from './components/am-booking-widget/am-booking-widget.component';
import { AmDatesSelectorComponent } from './components/am-dates-selector/am-dates-selector.component';
import { AmDurationSelectorComponent } from './components/am-duration-selector/am-duration-selector.component';
import { AmRoomSelectorComponent } from './components/am-room-selector/am-room-selector.component';
import { BookingWidgetCommonComponent } from './components/booking-widget-common/booking-widget-common.component';
import { BookingWidgetComponent } from './components/booking-widget/booking-widget.component';
import { BookingWidgetNotificationComponent } from './components/booking-widget-notification/booking-widget-notification.component';
import { BookingWidgetSelectorComponent } from './components/booking-widget-selector/booking-widget-selector.component';
import { CarRentalSearchWidgetComponent } from './components/car-rental-search-widget/car-rental-search-widget.component';
import { DiscountCodeComponent } from './components/discount-code/discount-code.component';
import { GlobalBookingWidgetSummaryHeaderComponent } from './components/global-booking-widget-summary-header/global-booking-widget-summary-header.component';
import { GuestsAndRoomsSelectorComponent } from './components/guests-and-rooms-selector/guests-and-rooms-selector.component';
import { HotelSearchWidgetComponent } from './components/hotel-search-widget/hotel-search-widget.component';
import { LocationSelectorComponent } from './components/location-selector/location-selector.component';
import { MulticitySelectorComponent } from './components/multicity-selector/multicity-selector.component';
import { PaxAmountSelectorComponent } from './components/pax-amount-selector/pax-amount-selector.component';
import { PreviousSearchesComponent } from './components/previous-searches/previous-searches.component';
import { ThirdPartyBookingWidgetComponent } from './components/third-party-booking-widget/third-party-booking-widget.component';
import { TravelDatesSelectorComponent } from './components/travel-dates-selector/travel-dates-selector.component';
import { TripTypeSelectorComponent } from './components/trip-type-selector/trip-type-selector.component';
import { bookingWidgetReducer } from './store/reducers/booking-widget.reducer';

@NgModule({
  imports: [
    CommonModule,
    PipesModule,
    UiTranslateModule,
    DirectiveModule,
    ButtonComponent,
    IconButtonComponent,
    DatepickerComponent,
    CheckboxInputComponent,
    RadioItemGroupComponent,
    SelectInputComponent,
    TextInputComponent,
    IconComponent,
    LinkComponent,
    LoaderComponent,
    ModalComponent,
    NotificationComponent,
    PopoverDirective,
    TabComponent,
    TabsComponent,
    TagComponent,
    FinFormsModule,
    ComponentsModule,
    LoginModule,
    StoreModule.forFeature(BOOKING_WIDGET_FEATURE_KEY, bookingWidgetReducer),
  ],
  providers: [BookingWidgetAmService],
  declarations: [
    AirCalendarComponent,
    BookingWidgetComponent,
    BookingWidgetSelectorComponent,
    PaxAmountSelectorComponent,
    LocationSelectorComponent,
    PreviousSearchesComponent,
    TripTypeSelectorComponent,
    TravelDatesSelectorComponent,
    DiscountCodeComponent,
    BookingWidgetNotificationComponent,
    AmBookingWidgetComponent,
    AmRoomSelectorComponent,
    AmDurationSelectorComponent,
    AmDatesSelectorComponent,
    GlobalBookingWidgetSummaryHeaderComponent,
    BookingWidgetCommonComponent,
    MulticitySelectorComponent,
    ThirdPartyBookingWidgetComponent,
    CarRentalSearchWidgetComponent,
    GuestsAndRoomsSelectorComponent,
    HotelSearchWidgetComponent,
  ],
  exports: [
    BookingWidgetComponent,
    BookingWidgetSelectorComponent,
    GlobalBookingWidgetSummaryHeaderComponent,
    BookingWidgetCommonComponent,
    TravelDatesSelectorComponent,
  ],
})
export class BookingWidgetModule {}
